// ============================================
// DistributorProgress — Barras de progreso y regalos para distribuidoras
// ============================================

import React from 'react';
import { DISTRIBUTOR_TIER_IMAGES } from '../account/distributorTierImages';
import './DistributorProgress.css';

const fmt = (n) =>
  '$' + Number(n || 0).toLocaleString('es-MX', { maximumFractionDigits: 0 });

// Misma foto que el nivel en el panel de socia (por posición del nivel).
const tierImage = (tiers, tier) => DISTRIBUTOR_TIER_IMAGES[tiers.findIndex((x) => x.id === tier.id)];

export default function DistributorProgress({
  isDistributor,
  reachedMin,
  missingToMin,
  minProgress,
  minTotal,
  tiers = [],
  achievedTiers,
  nextTier,
  missingToNext,
  nextTierProgress,
}) {
  if (!isDistributor) return null;

  return (
    <div className="distprog">
      <div className="distprog-header">
        <span className="distprog-badge">Programa distribuidoras</span>
      </div>

      {/* Mínimo de pedido */}
      <div className="distprog-section">
        <div className="distprog-row">
          <span className="distprog-label">Mínimo de pedido</span>
          <span className="distprog-value">{fmt(minTotal)}</span>
        </div>
        <div className="distprog-bar">
          <div
            className={`distprog-bar-fill ${reachedMin ? 'is-complete' : ''}`}
            style={{ width: `${Math.round(minProgress * 100)}%` }}
          />
        </div>
        <p className="distprog-help">
          {reachedMin
            ? '✓ Listo para finalizar pedido.'
            : `Te faltan ${fmt(missingToMin)} para poder finalizar el pedido.`}
        </p>
      </div>

      {/* Próximo regalo */}
      {nextTier && (
        <div className="distprog-section">
          <div className="distprog-row">
            <span className="distprog-label">
              Próximo regalo · {nextTier.label}
            </span>
            <span className="distprog-value">{fmt(nextTier.min_amount)}</span>
          </div>
          <div className="distprog-bar">
            <div
              className="distprog-bar-fill is-tier"
              style={{ width: `${Math.round(nextTierProgress * 100)}%` }}
            />
          </div>
          <p className="distprog-help">
            Te faltan {fmt(missingToNext)} para desbloquearlo.
          </p>
        </div>
      )}

      {/* Regalos ya ganados */}
      {achievedTiers.length > 0 && (
        <div className="distprog-section">
          <span className="distprog-label">Regalos en este pedido</span>
          <ul className="distprog-gifts">
            {achievedTiers.map((t) => (
              <li key={t.id} className="distprog-gift-item">
                <span className="distprog-gift-thumb" aria-hidden="true">
                  {tierImage(tiers, t) && <img src={tierImage(tiers, t)} alt="" loading="lazy" />}
                </span>
                <span>{t.label}</span>
                <span className="distprog-gift-muted">{fmt(t.min_amount)}+</span>
              </li>
            ))}
          </ul>
          <p className="distprog-help">
            Se agregan automáticamente al carrito al finalizar.
          </p>
        </div>
      )}
    </div>
  );
}
